
import { envConfig } from "@env/env-config";

export const AddressRestServiceConfig: Array<qpmn.common.rest.IServiceConfig> = [

    /** 添加地址簿 */
    {
        service: "addressRestService",
        funcName: "addAddressBook",
        config: {
            method: "post",
            appPath: envConfig.apps.base,
            path: "/api/partner/addressBooks",
        }
    },

    /** 搜索地址簿 */
    {
        service: "addressRestService",
        funcName: "searchAddressBookById",
        config: {
            method: "get",
            appPath: envConfig.apps.base,
            path: "/api/partner/addressBooks/:addressBookId",
            paramDefaults: { addressBookId: "@addressBookId" }
        }
    },

    /** 删除地址簿 */
    {
        service: "addressRestService",
        funcName: "deleteAddressBookById",
        config: {
            method: "delete",
            appPath: envConfig.apps.base,
            path: "/api/partner/addressBooks/:addressBookId",
            paramDefaults: { addressBookId: "@addressBookId" }
        }
    },
    /** 批量删除地址簿 */
    {
        service: "addressRestService",
        funcName: "deleteAddressBooks",
        config: {
            method: "delete",
            appPath: envConfig.apps.base,
            path: "/api/partner/addressBooks",
            paramDefaults: { ids: "@addressBookIds" }
        }
    },

    /** 更新地址簿 */
    {
        service: "addressRestService",
        funcName: "updateAddressBookById",
        config: {
            method: "put",
            appPath: envConfig.apps.base,
            path: "/api/partner/addressBooks/:addressBookId",
            paramDefaults: { addressBookId: "@id" }
        }
    },

    /** 获取所有地址簿 */
    {
        service: "addressRestService",
        funcName: "getAddressBooks",
        config: {
            method: "get",
            appPath: envConfig.apps.base,
            path: "/api/partner/addressBooks",
        }
    },
    /** 获取默认地址簿 */
    {
        service: "addressRestService",
        funcName: "getDefaultAddressBook",
        config: {
            method: "get",
            appPath: envConfig.apps.base,
            path: "/api/partner/addressBooks/default",
        }
    }

]